import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_ROUTE_INVOICE_LOADING = 'DELETE_ROUTE_INVOICE_LOADING';
export const DELETE_ROUTE_INVOICE_SUCCESS = 'DELETE_ROUTE_INVOICE_SUCCESS';
export const DELETE_ROUTE_INVOICE_RESET = 'DELETE_ROUTE_INVOICE_RESET';
export const DELETE_ROUTE_INVOICE_REJECT = 'DELETE_ROUTE_INVOICE_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteRouteInvoiceLoading = () => ({ type: DELETE_ROUTE_INVOICE_LOADING });
export const deleteRouteInvoiceSuccess = (payload) => ({ type: DELETE_ROUTE_INVOICE_SUCCESS, payload });
export const deleteRouteInvoiceReset = () => ({ type: DELETE_ROUTE_INVOICE_RESET });
export const deleteRouteInvoiceReject = (payload) => ({ type: DELETE_ROUTE_INVOICE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteRouteInvoiceRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
        data,
    }, getState);
    return request(`/ProvidersBillingTracking/web/DeleteProvidersBillingTrackingRoute`, options);
};